<template>
    <b-card 
        :title="translations.createOrder[lang]" 
        @cancel="$emit('close')" 
        @submit="createOrder"
        :error-message="errorMessage"
        :loading="loading"
        :disabled="!formValid"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >

    <b-text-field
        :label="translations.volume[lang]"
        v-model="loyaltyCard.volume"
        hint="type how many cards to order, minimum is 50"
        no-margin-top
        :success="success.volume"
        :error-messages="error.volume"
        @focus="error.volume = ''"
        @blur="validateVolume"
    ></b-text-field>

    <b-select
        :items="cardTypes"
        item-text="name"
        item-value="value"
        v-model="loyaltyCard.card_type"
        :label="translations.cardType[lang]"
        :success="success.card_type"
        :error-messages="error.card_type"
        @focus="error.card_type = ''"
        @blur="validateCardType"
    ></b-select>
        
    </b-card>
</template>

<script>
import { mdiPlus } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import validators from "@/utils/validators/loyaltyPanel/loyaltyCard";
import translations from "@/utils/translations/loyaltyPanel/loyaltyCards";

export default {
    name: "LoyaltyCardForm",

    mixins: [validators, translations],

    data: () => ({
        icons: {
            mdiPlus
        },
        cardTypes: [
            {
                name: "QR code",
                value: "qr",
            },
            {
                name: "Barcode",
                value: "barcode",
            },
        ],
    }),
    computed:{
        ...mapState(["loading", "errorMessage"]),

        loyaltyCard: {
            get() {
                return this.$store.state.loyaltyPanel.loyaltyCards.loyaltyCard;
            },
            set(val){
                this.setLoyaltyCard(val)
            }
        },

        lang() {
            return this.$route.params.lang;
        }
    },
    methods: {
        ...mapActions("loyaltyPanel/loyaltyCards", [
            "createOrder",
            ]),
        ...mapMutations("loyaltyPanel/loyaltyCards", [
            "setLoyaltyCard"
            ])
    }
};
</script>
